'use client'

interface CustomJsonLdProps {
  id: string
  data: Record<string, unknown>
}

/**
 * Renders a single JSON-LD block as a server-rendered
 * <script type="application/ld+json"> tag for SEO.
 */
const CustomJsonLd = ({ id, data }: CustomJsonLdProps) => (
  <script
    id={id}
    type="application/ld+json"
    dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, '\\u003c') }}
  />
)

export default CustomJsonLd
